export enum FeeWaiverAuditLogActionTypeEnum {
    CREATE = 1,
    CHANGE_NAME = 2,
    CHANGE_LOCKED_STATUS = 3,
    REMOVE = 4,
}

export const feeWaiverAuditLogActionTypeText: { [key in FeeWaiverAuditLogActionTypeEnum]: string } = {
    [FeeWaiverAuditLogActionTypeEnum.CREATE]: 'Created',
    [FeeWaiverAuditLogActionTypeEnum.CHANGE_NAME]: 'Renamed',
    [FeeWaiverAuditLogActionTypeEnum.CHANGE_LOCKED_STATUS]: 'Locked Status',
    [FeeWaiverAuditLogActionTypeEnum.REMOVE]: 'Removed',
};
